import Vue from "vue";
import moment from "moment";

var lookup_model_meta = {
  FeeTypes: {
    url: "/fees",
    lookupName: "FeeTypes",
    idField: "feeid",
    valueField: "feetype"
  },
  ScopesOfPractice: {
    url: "/scopesofpractice",
    lookupName: "ScopesOfPractice",
    idField: "scopeofpracticeid",
    valueField: "name"
  },
  AccreditationType: {
    url: "/accreditationtypes",
    lookupName: "AccreditationTypes",
    idField: "id",
    valueField: "description"    
  },
  Institutions: {
    url: "/institutions",
    lookupName: "Institutions",
    idField: "institutionid",
    valueField: "name"
  },
  Quals: {
    url: "/quals",
    lookupName: "Quals",
    idField: "qualid",
    valueField: "name"
  },
  ConditionTypes: {
    url: "/conditiononpracticevalues",
    lookupName: "ConditionTypes",
    idField: "conditionid",
    valueField: "conditiondescription"
  },
  PracticingStatusOption: {
    url: "/practicingstatusoptions",
    lookupName: "PracticingStatusOption",
    idField: "name",
    valueField: "name"
  }
  // default: {
  //   url: "/lookupvalues",
  //   lookupName: "",
  //   idField: "valueid",
  //   valueField: "value"
  // }
};

function getLookupModel(lookupName) {
  if (lookup_model_meta[lookupName]) {
    return lookup_model_meta[lookupName];
  } else {
    //get /url

    return {};
  }
}

const state = {
  loadedAt: localStorage.getItem("marco_state_lookups_loadedAt") || "",
  lookupsByName: {}
};

//get lookups from local cache

const getters = {
  lookup: state => (lookupName, lookupId = null, prop = "value") => {
    if (!lookupName) return [];
    // console.debug("getting lookup: ", lookupId, lookupName, prop);
    let lookups = state.lookupsByName[lookupName];
    if (!lookups) return [];
    // console.debug("using lookups list: ", lookups);
    if (lookupId != null) {
      let theVal = lookups.find(value => value.valueid == lookupId);
      // console.debug("lookups found: ", theVal);
      if (!theVal) {
        return prop ? false : [];
      }
      return theVal[prop];
    }
    if (lookupId === false) {
      return false;
    }
    // if (lookupId === true) {
    //return null if lookupId is explicitly set to FALSE
    return state.lookupsByName[lookupName];
    // }
  },
  lookups: state => {
    return state.lookupsByName;
  }
};

const mutations = {
  saveLookupOptions(state, { name, values }) {
    console.debug("saving lookup options: ", name, values);
    Vue.set(state.lookupsByName, name, values);
  },
  setLookupOptions(state, lookups) {
    state.lookupsByName = { ...lookups };
  },

  saveToCache(state) {
    let now = new Date();
    now = now.toISOString();
    state.loadedAt = now;
    // console.debug("saving state to cache: ", state);
    localStorage.setItem(
      "marco_state_lookups_byName",
      JSON.stringify({ ...state.lookupsByName })
    );
    localStorage.setItem("marco_state_lookups_loadedAt", now);
  }
};

const actions = {
  async maybeLoadFromCache({ state, commit }) {
    commit(
      "setLookupOptions",
      JSON.parse(localStorage.getItem("marco_state_lookups_byName"))
    );

    // console.debug("checking cache: ", state.loadedAt);
    let mostRecentUpdate = state.loadedAt || new Date();
    try {
      let option = await Vue.axios.get("options/lookupsUpdated");
      if (option.data.updated) {
        mostRecentUpdate = option.data.updated;
      }
    } catch (e) {
      console.error("Error loading lookups update time", e, mostRecentUpdate);
    }
    let cacheExpiry = moment(state.loadedAt).add(24, "hours");
    // console.debug("cache Expiry: ", cacheExpiry);

    if (
      state.loadedAt &&
      moment().isBefore(cacheExpiry) &&
      moment(state.loadedAt).isSameOrAfter(mostRecentUpdate)
    ) {
      // console.debug("loading state from cache: ", state);

      return true;
    }
    return false;
  },
  LOAD_CONFIG: async ({ commit, dispatch }) => {
    commit("AddAppLoading");
    // console.debug("Vue Axios: ", Vue.axios);
    var cached = await dispatch("maybeLoadFromCache");
    // console.debug("maybeLoadFromCached returned: ", cached);
    if (cached) {
      commit("RemoveAppLoading");
    }

    try {
      // console.debug("not cached");
      var response = await Vue.axios({ url: "/lookups" });

      if (!response.data) {
        return;
      }

      response.data.forEach(lookup => {
        commit("saveLookupOptions", {
          name: lookup.name,
          values: lookup.values
        });
      });

      var requests = [];
      /* eslint-disable-next-line */
      for (const lookupName in lookup_model_meta) {
        requests.push(
          dispatch("LOAD_LOOKUP_DATA", lookup_model_meta[lookupName])
        );
      }
      // console.log(requests);
      await Promise.all(requests);
    } catch (e) {
      console.error("Error while loading lookups config: ", e);
      throw e;
    }
    commit("saveToCache");
    commit("RemoveAppLoading");
  },
  LOAD_LOOKUP_DATA: async (
    { commit },
    { url, lookupName, idField, valueField }
  ) => {
    //load lookup
    // commit("AddAppLoading");
    return Vue.axios.get(url).then(response => {
      // commit("RemoveAppLoading");
      if (!response.data) return;

      var tempLookup = [];
      /* eslint-disable-next-line */
      for (const item of response.data) {
        tempLookup.push({
          ...item,
          valueid: item[idField],
          value: item[valueField]
        });
      }

      return commit("saveLookupOptions", {
        name: lookupName,
        values: tempLookup
      });
    });
    //finish loading lookup
  },
  ADD_LOOKUP_OPTION: async ({ dispatch }, { lookupName, lookupValue }) => {
    //load lookup
    // commit("AddAppLoading");
    var lookup_meta = getLookupModel(lookupName);

    // commit("RemoveAppLoading");
    var newLookup = {};
    newLookup[lookup_meta.valueField] = lookupValue;
    var response = await Vue.axios.post(lookup_meta.url, newLookup);
    if (!response.data) return false;

    return await dispatch("LOAD_LOOKUP_DATA", lookup_meta);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
